/**
 * @param {Function} estadoNotificacion - Función para actualizar el estado de la notificación en el componente padre.
 * @param {'registro' | 'actualizacion' | 'eliminar'} type - Tipo de notificación. Define el color de fondo.
 * @param {string} mensaje - Texto que se mostrará en la notificación.
 * @param {Function} [onClose] - (Opcional) Función que se ejecuta al cerrar la notificación.
 * @param {number} [duracion=4000] - Tiempo en milisegundos antes de que la notificación se cierre automáticamente.
 */

import React, { useEffect, useState } from "react"

const Notification = ({ estadoNotificacion, type="registro", mensaje, onClose, duracion = 4000 }) => {
  const [visible, setVisible] = useState(true) // Comienza visible

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false) // Oculta la notificación
      estadoNotificacion(false)
    }, duracion)

    return () => clearTimeout(timer) // Limpia el timeout al desmontar
  }, [duracion, onClose])

  if (!visible) return null // Si no es visible, no renderiza nada

  // Establecer el color de fondo según el tipo de notificación
  let backgroundColor = ""
  switch (type) {
    case "registro":
      backgroundColor = "bg-green-500" // Verde para registro
      break
    case "actualizacion":
      backgroundColor = "bg-orange-500" // Amarillo para actualización
      break
    case "eliminar":
      backgroundColor = "bg-red-500" // Rojo para eliminación
      break
    default:
      backgroundColor = "bg-green-500" // Default es verde (registro)
  }

  return (
    <div
      className={`fixed top-4 right-4 p-4 z-10 rounded-md shadow-md transition-transform transform ${backgroundColor} text-white`}
    >
      {mensaje}
      <button
        onClick={() => {
          setVisible(false) // Oculta al hacer clic en cerrar
        }}
        className="ml-4 text-white font-bold hover:text-gray-200"
      >
        ✕
      </button>
    </div>
  )
}

export default Notification
